import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M23.5 3.5c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20m0-2.5C11.1 1 1 11.1 1 23.5S11.1 46 23.5 46 46 35.9 46 23.5 35.9 1 23.5 1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M23.5 10C30.9 10 37 16 37 23.5S30.9 37 23.5 37 10 30.9 10 23.5 16.1 10 23.5 10m0-2.5c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "34.8 23.5 29.5 20.4 29.5 22.2 24.8 22.2 24.8 17.5 26.6 17.5 23.5 12.2 20.4 17.5 22.2 17.5 22.2 22.2 17.5 22.2 17.5 20.4 12.2 23.5 17.5 26.6 17.5 24.8 22.2 24.8 22.2 29.5 20.4 29.5 23.5 34.8 26.6 29.5 24.8 29.5 24.8 24.8 29.5 24.8 29.5 26.6"
		})
	]
});
export default SvgIcon;
